import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import { useHistory } from "react-router-dom";
import swal from "@sweetalert/with-react";
import TextField from "@material-ui/core/TextField";
import axios from "axios";
import GlobalApi from "../../Global";
import DarkButton from "./../../Global/DarkButton"
import Colors from "./../../Global/colors"
import Spinner from "./../../Global/Spinner"

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  custommodal: {},
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle
      disableTypography
      className="custom-modal"
      
      {...other}
    >
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function CustomizedDialogs({
  onClose,
  open,
  handleSubmit,
  onNewGroupAdded,
}) {
  // const [open, setOpen] = React.useState(true);
  const [Action, setAction] = React.useState({
    title: "",
    description: "",
  });
  const [packageDetails, setPackageDetails] = React.useState(null);
  const history = useHistory();
  React.useEffect(() => {
    getPackageDetails();
  }, [open]);

  async function getPackageDetails() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let package_inquiry = {
      user_id: data.user_id,
      organization_id: data.organization_id,
    };

    let query = Object.keys(package_inquiry)
      .map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
      )
      .join("&");
    let req = await fetch(
      GlobalApi + "/Package/get_user_license_details?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );

    let reqJson = await req.json();

    console.log("reqJson",reqJson)

    if (reqJson?.package?.license?.status === "expired" || reqJson?.package?.license?.status === "deactive") {
      history.replace("/billing");
    } else {
      setPackageDetails(reqJson.package);
    }

    
  }

  const handleClose = () => {
    // setOpen(false);
    onClose();
  };

  if (packageDetails !== null) {
    return <Dialog onClose={() => {
          setAction("", "");
          handleClose();
        }} //aria-labelledby="customized-dialog-title"
        open={open} fullWidth maxWidth={"sm"}>
        
        <DialogTitle id="customized-dialog-title" //className="custom-modal"
          style={{ background: Colors.globalColor9 }}>
    
          <p className="label2" style={{ marginBottom: 5, fontSize: 16, marginTop: 7, color: Colors.globalColor8, textTransform: "uppercase" }}>
            Create New Action
          </p>
          <p className="label2" style={{ marginBottom: 5, fontSize: 10, marginTop: 0, color: "grey", textTransform: "capitalized" }}>
            {packageDetails?.action_count + "/" + (packageDetails.action_limit === "Unlimited" || packageDetails.action_limit === "yes" ? "~" : packageDetails.action_limit) + " actions have been created"}
          </p>
        </DialogTitle>
        <br />
        <div className="col s12" style={{ padding: "20px" }}>
          <TextField id="outlined-basic" name="" value={Action.title ? capitalize(Action.title) : Action.title} error="" onChange={(e) => setAction(
                { ...Action, title: e.target.value }
              )} helperText="" fullWidth autoComplete="off" className="textfield-chng1" label="Title of action" variant="outlined" />
          <br />
          <br />
          <div className="col s12 left-align">
            {/* <TextareaAutosize
                style={{ borderRadius: "5px",width: "100%"}}
                value={Action.description}
                aria-label="minimum height"
                rowsMin={3}
                autoComplete='off'
                placeholder="Description"
                onChange={(e) =>
                  setAction({ ...Action, description: e.target.value })
                }
              /> */}
            <TextField id="outlined-basic" name="" value={Action.description} error="" fullWidth onChange={(e) => setAction(
                  { ...Action, description: e.target.value }
                )} helperText="" autoComplete="off" className="textfield-chng1" label="Description" variant="outlined" multiline rows={3} />
          </div>
        </div>
        <DialogActions>
          <Grid container direction="column" justify="center">
            <Grid item xs={12}>
              {((packageDetails?.action_limit != "Unlimited"  ? parseInt(packageDetails.action_limit) > parseInt(packageDetails.action_count) : true) ||  packageDetails?.action_limit == "yes") ? <>
                  {/* <Button autoFocus onClick={() => {
                      setAction("", "");
                      handleClose();
                    }} style={{ //background: "#00a0dc",
                      color: Colors.globalColor8, margin: 3, fontWeight: "bold" }}>
                    Cancel
                  </Button> */}

                  <Button variant="contained" className="cancelBtn"onClick={() => {
                      setAction("", "");
                      handleClose();
                    }} style={{ //background: "#00a0dc",
                      color: Colors.globalColor8, margin: 3, fontWeight: "bold" }}>
                    Cancel
                  </Button>


                  {/* <DarkButton
                      autoFocus
                      onClick={() => handleSubmit(Action)}
                      style={{
                        background: Colors.globalColor8,
                        color: "white",
                        margin: 3,
                      }}
                    >
                      Create
                    </DarkButton> */}

                  <Button variant="contained" type="submit" className="addBtn" component="span" autoFocus onClick={() => handleSubmit(Action)} style={{ background: Colors.globalColor8, color: "white", margin: 3 }}>
                    {"Create"}
                  </Button>
                </> :
                <Button variant="contained" type="submit" className="addBtn" component="span"  onClick={() => history.push("/update_package")} style={{ background: Colors.globalColor8, color: "white" }}>
                {"Upgrade package"}
              </Button>

                // <DarkButton // autoFocus
                //   onClick={() => history.push("/update_package")} style={{ background: Colors.globalColor8, color: "white" }}>
                //   Upgrade package
                // </DarkButton>
                }
            </Grid>
            <Grid item xs={12} md={12} />
          </Grid>

          {/* </Link> */}
        </DialogActions>
      </Dialog>;
  } else {
    return "";
  }
}
